import React from 'react';
import { connect } from 'react-redux';
import WP from 'WP';

import Checkout from './Checkout';
import CheckoutDisabled from './CheckoutDisabled';

/**
 * CheckoutGuard - Wrapper component that controls checkout availability
 * 
 * Checks the WordPress option 'bjorknes_checkout_enabled' to determine
 * whether the checkout is enabled or disabled.
 * 
 * IMPORTANT: Checkout is ENABLED BY DEFAULT
 * - If option doesn't exist -> Checkout enabled
 * - If WP.options.bjorknes_checkout_enabled !== false -> Checkout enabled
 * - If WP.options.bjorknes_checkout_enabled === false -> Shows maintenance page
 * 
 * Configuration (NO REBUILD REQUIRED):
 * 
 * Via WP-CLI:
 *   wp option update bjorknes_checkout_enabled false  # Disable checkout
 *   wp option update bjorknes_checkout_enabled true   # Enable checkout
 * 
 * Via WordPress PHP:
 *   update_option('bjorknes_checkout_enabled', false);  # Disable
 *   update_option('bjorknes_checkout_enabled', true);   # Enable
 * 
 * See CHECKOUT_CONFIG.md for complete documentation
 */
const CheckoutGuard = ({ visible }) => {
    // Check if checkout is visible (opened)
    if (!visible) {
        return null;
    }

    // Check WordPress option
    // Checkout is ENABLED by default (only disabled when explicitly set to false)
    const isCheckoutEnabled = WP.options.bjorknes_checkout_enabled !== false;

    // If checkout is disabled, show maintenance page
    if (!isCheckoutEnabled) {
        return <CheckoutDisabled />;
    }

    // Otherwise, render normal checkout
    return <Checkout />;
};

const mapStateToProps = state => ({
    visible: state.checkout.visible
});

export default connect(mapStateToProps)(CheckoutGuard);




// WEBPACK FOOTER //
// ./src/partials/Checkout/CheckoutGuard.js